import { render, staticRenderFns } from "./icontent.vue?vue&type=template&id=52dd7278"
import script from "./icontent.vue?vue&type=script&lang=js"
export * from "./icontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports